import React from "react";
import { Wrench, ArrowRight } from "lucide-react";

/**
 * Generic placeholder shown for Phase-2 modules.
 * The route itself is still permission-gated server-side; this component
 * is only rendered if the user already has view-permission for the module.
 */
export default function PlaceholderSection({ title, description, items, testId }) {
  return (
    <div data-testid={testId}>
      <h1 className="font-chivo font-black text-3xl text-[#0A192F] tracking-tight">{title}</h1>
      <p className="text-sm text-gray-600 mt-1">{description}</p>

      <div className="mt-8 bg-white border-2 border-dashed border-gray-300 p-8 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-[#0055FF]/10 mb-4">
          <Wrench className="w-6 h-6 text-[#0055FF]" />
        </div>
        <h2 className="font-chivo font-black text-xl text-[#0A192F]">Module wordt geïmplementeerd in fase 2</h2>
        <p className="text-sm text-gray-600 mt-2 max-w-md mx-auto">
          De toegangsrechten en database-modellen voor deze module zijn al actief. De UI volgt in de
          volgende oplevering.
        </p>
        {items && items.length > 0 && (
          <div className="mt-6 max-w-md mx-auto text-left">
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#0055FF] font-chivo font-bold mb-2">
              Geplande functionaliteit
            </div>
            <ul className="space-y-1">
              {items.map((it, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                  <ArrowRight className="w-3.5 h-3.5 mt-0.5 text-[#0055FF] flex-shrink-0" />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
